import { render, staticRenderFns } from "./dealerMoveModel.vue?vue&type=template&id=99852108&scoped=true&"
import script from "./dealerMoveModel.vue?vue&type=script&lang=js&"
export * from "./dealerMoveModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99852108",
  null
  
)

export default component.exports